import querystring from 'querystring';

export function getOrigin(url: string) {
  const a = document.createElement('a');
  a.href = url;
  return `${a.protocol}//${a.host}`;
}

export function parseQueryString(str: string): {[index:string]:string} {
  if(!str || str === '?') {
    return {};
  }
  if(str[0] === '?') {
    str = str.substr(1);
  }
  const values = querystring.decode(str);
  const params: {[index:string]:string} = {};
  for(const key of Object.keys(values)) {
    const val = values[key];
    params[key] = Array.isArray(val) ? (val.length > 0 ? val[0] : '') : val;
  }
  return params;
}

export function formatQueryString(params: {[index:string]:string|string[]}): string {
  return querystring.encode(params);
}

export function tryParseURL(url: string): URL|null {
  try {
    return new URL(url);
  } catch(ex) {
    return null;
  }
}